<div class="absolute inset-0 flex min-w-0 flex-col overflow-hidden">
    <mat-drawer-container
        class="bg-card h-full flex-auto dark:bg-transparent"
        (backdropClick)="onBackdropClicked()"
    >
        <!-- Drawer -->
        <mat-drawer
            class="w-150 dark:bg-gray-900"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            [position]="'end'"
            #matDrawer
        >
            <ng-container *ngIf="drawerOpened">
                <app-court
                    [venueId]="venueId"
                    [data]="selectedCourt"
                    (clicked)="close($event)"
                ></app-court>
            </ng-container>
        </mat-drawer>

        <mat-drawer-content class="flex flex-col">
            <!-- Main -->
            <div class="flex flex-auto flex-col">
                <!-- Header -->
                <div class="bg-default flex flex-col items-start px-6 py-8 sm:flex-row sm:items-center sm:justify-between md:px-8">
                    <!-- Title -->
                    <div>
                        <div class="text-4xl font-extrabold leading-none tracking-tight">{{venue.name}} Courts</div>
                        <div class="text-secondary ml-0.5 font-medium">
                            <span>Manage all courts from the Venue</span>
                        </div>
                    </div>
                    <!-- Actions -->
                    <div class="mt-4 sm:mt-0">
                        <!-- Add section button -->
                        <button
                            class="ml-3"
                            mat-flat-button
                            [color]="'primary'"
                            (click)="editCourt(null)"
                        >
                            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                            <span class="ml-2 mr-1">Add Court</span>
                        </button>
                    </div>

                </div>
                <table
                    class="bg-card w-full text-left border-separate border-spacing-0 mat-elevation-z0 !bg-white"
                    mat-table
                    matSort
                    matSortActive="name"
                    matSortDirection="asc"
                    (matSortChange)="onSortChange($event)"
                    [dataSource]="recentTransactionsDataSource"
                    [trackBy]="trackByFn"
                    #recentTransactionsTable
                >
                    <!-- Venue -->

                    <ng-container matColumnDef="sportLogo">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="sports"
                            class="!px-6 py-3 font-medium tracking-wide text-gray-600"
                        >
                            Sport
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4 whitespace-nowrap"
                        >
                            <div class="flex items-center space-x-2">
                                <img
                                    [src]="transaction.sportLogo"
                                    alt="sport logo"
                                    class="h-8 w-8"
                                    *ngIf="transaction.sportLogo"
                                >
                                <span class="text-gray-900 font-medium">{{ getSportDisplayName(transaction.sports) }}</span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Court Name -->
                    <ng-container matColumnDef="name">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="name"
                            class="!px-6 py-3 font-medium tracking-wide text-gray-600"
                        >
                            Court Name
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4 whitespace-nowrap"
                        >
                            <span class="font-medium text-gray-900">{{ transaction.name }}</span>
                        </td>
                    </ng-container>

                    <!-- Type -->
                    <ng-container matColumnDef="courtType">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="courtType"
                            class="!px-6 py-3 font-medium tracking-wide text-gray-600"
                        >
                            Court Type
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4"
                        >
                            <span
                                class="inline-flex items-center rounded-full px-3 py-1 font-medium"
                                [ngClass]="{
                                    'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50':
                                        transaction.courtType === 'outdoor',
                                    'bg-purple-200 text-purple-800 dark:bg-purple-600 dark:text-purple-50':
                                        transaction.courtType === 'indoor',
                                }"
                            >
                                {{ transaction.courtType | titlecase }}
                            </span>

                        </td>
                    </ng-container>

                    <!-- Surface -->
                    <ng-container matColumnDef="surfaceType">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="surfaceType"
                            class="!px-6 py-3 font-medium tracking-wide text-gray-600"
                        >
                            Surface Type
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4"
                        >
                            <span class="text-gray-700">{{ transaction.surfaceType | titlecase }}</span>
                        </td>
                    </ng-container>

                    <!-- Min Capacity -->
                    <ng-container matColumnDef="minCapacity">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="minCapacity"
                            class="!px-6 py-3 font-medium tracking-wide text-gray-600"
                        >
                            Minimum Capacity
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4"
                        >
                            <span class="font-semibold text-indigo-600">{{ transaction.minCapacity }}</span>
                        </td>
                    </ng-container>

                    <!-- Max Capacity -->
                    <ng-container matColumnDef="maxCapacity">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="maxCapacity"
                            class="!px-6 py-3 font-medium tracking-wide text-gray-600"
                        >
                            Max Capacity
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4"
                        >
                            <span class="font-semibold text-indigo-600">{{ transaction.maxCapacity }}</span>
                        </td>
                    </ng-container>

                    <!-- Price/Hour -->
                    <ng-container matColumnDef="pricePerHour">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="pricePerHour"
                            class="!px-6 py-3 font-medium tracking-wide text-gray-600"
                        >
                            Price/Hour
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4"
                        >
                            <span class="text-gray-700">
                                {{ transaction.pricingRules?.length ? 'From ' : '' }}{{ formatAedCurrency(getStartingPrice(transaction)) }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Status -->
                    <ng-container matColumnDef="actions">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            class="!px-6 py-3 font-medium tracking-wide text-gray-600"
                        >
                            Actions
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4"
                        >
                            <button
                                mat-icon-button
                                (click)="editCourt(transaction)"
                                matTooltip="Edit Court"
                            >
                                <mat-icon [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
                            </button>
                            <button
                                mat-icon-button
                                color="warn"
                                (click)="delete(transaction.id)"
                                matTooltip="Delete Venue"
                            >
                                <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <!-- Footer -->
                    <ng-container matColumnDef="recentOrdersTableFooter">
                        <td
                            class="border-0 px-0 py-6"
                            mat-footer-cell
                            *matFooterCellDef
                            colspan="6"
                        ></td>
                    </ng-container>

                    <!-- Header row -->
                    <tbody>
                        <tr
                            mat-header-row
                            *matHeaderRowDef="recentTransactionsTableColumns"
                            class="border-b border-gray-200"
                        ></tr>

                        <!-- Data rows -->
                        <tr
                            class="h-16 border-b border-gray-200 hover:!bg-gray-50 transition-colors"
                            mat-row
                            *matRowDef="let row; columns: recentTransactionsTableColumns"
                        ></tr>

                        <!-- Footer row -->
                        <tr
                            class="h-16 border-0"
                            mat-footer-row
                            *matFooterRowDef="['recentOrdersTableFooter']"
                        ></tr>
                    </tbody>
                </table>
                <mat-paginator
                    [length]="totalItems"
                    [pageIndex]="pageIndex"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="[5, 10, 25, 50]"
                    [showFirstLastButtons]="true"
                    (page)="onPageChange($event)"
                ></mat-paginator>

            <div *ngIf="recentTransactionsDataSource.data.length === 0" class="text-center py-12">
                <div class="max-w-md mx-auto">
                    <mat-icon class="text-8xl text-gray-300 mb-4" style="font-size: 96px; height: 96px; width: 96px;">sports_tennis</mat-icon>
                    <h3 class="text-xl font-semibold text-gray-600 mb-2">No Courts Available</h3>
                    <p class="text-gray-500">This venue doesn't have any courts added yet.</p>
                </div>
            </div>

            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>
